import api from '@/services/api';

// Object
const getDocument = (documentId) => api()
  .get(`documents/${documentId}`);

// Generate Document
const previewDocument = (documentId) => api()
  .get(`documents/${documentId}/preview`);

const generateContractDocuments = (contractId) => api()
  .post('documents/generate_contracts', { id: contractId });

const generateInvoiceDocuments = (invoiceId) => api()
  .post('documents/generate_invoices', { id: invoiceId });

const getPreviousSignatureRequest = (documentId) => api()
  .get(`signaturerequest${documentId}`);

const sendDocument = (documentId, message) => api()
  .post(`documents/${documentId}/send`, message);

const findSignature = () => api()
  .get('signature');

const postSignature = ({ companyId, signers, contractDocuments }) => api()
  .post('signature', {
    companyId,
    signers,
    contractDocuments,
  });

const signatureRequest = (requestId, event) => api()
  .post('signature/callback', { requestId, event });

const findSignatureUrlFromId = (signatureId) => api()
  .put(`signature/${signatureId}`);

const getSignatureFromId = (signatureId) => api()
  .get(`signature/${signatureId}`);

const sendSignature = (id, message) => api()
  .post(`signature/${id}/send`, message);

const POLICY_STATUSES_WITH_DOCUMENTS = ['ACTIVE', 'SUSPENDED', 'CANCELLED'];

function canRequestPolicyDocuments(status) {
  return POLICY_STATUSES_WITH_DOCUMENTS.includes(status);
}

function findDocumentsByPolicyId(id) {
  return api().get(`/policies/${id}/documents`);
}

function findCurrentDocumentsByPolicyId(id) {
  return api().get(`/policies/${id}/current-documents`);
}

function findLastCertificateByPolicyId(id) {
  return api().get(`/policies/${id}/documents?filters=template.documentType:eq:CERTIFICATE&sort=-createdAt`);
}

export {
  generateContractDocuments,
  generateInvoiceDocuments,
  getDocument,
  findDocumentsByPolicyId,
  canRequestPolicyDocuments,
  findCurrentDocumentsByPolicyId,
  getPreviousSignatureRequest,
  findSignature,
  findSignatureUrlFromId,
  getSignatureFromId,
  sendDocument,
  previewDocument,
  signatureRequest,
  findLastCertificateByPolicyId,
  postSignature,
  sendSignature,
};
